export const styles = {
  global: {
    body: {
      bg: "gray.900",
      color: "white",
    },
  },
};
